/** @prettier */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Typography } from '@material-ui/core';
import ClaimFormFooter from 'src/components/ClaimFormFooter';
import ClaimHeader from './claim-header';
import useClaim from 'src/hooks/useClaimContext';
import ClaimReviewOverview from './glass/components/ClaimReviewOverview';
import ClaimReviewFeatures from './glass/components/ClaimReviewFeatures';
import ClaimReviewTotals from './glass/components/ClaimReviewTotals';

export default function ClaimReview({ goBack, dealerInfo, orderInfo, claimContactInfo, onSubmitClaim }) {
  const { t } = useTranslation();
  const { claimReview, claimRequest, formState, updateFormState } = useClaim();

  return (
    <Box component="main" p={4}>
      <ClaimHeader
        dealerInfo={dealerInfo}
        orderInfo={orderInfo}
        claimContactInfo={claimContactInfo}
        showTitle={false}
      />
      <Typography variant="h3" color="textPrimary">{t('reviewGlassClaim')}</Typography>
      <ClaimReviewOverview claim={claimReview} />
      <ClaimReviewFeatures claim={claimReview} />
      <ClaimReviewTotals claim={claimReview} />
      <Formik
        initialValues={{}}
        validationSchema={Yup.object({})}
        onSubmit={async ({ setErrors }) => {
          try {
            updateFormState({ isSubmitting: true });
            await onSubmitClaim(claimRequest);
          } catch (error) {
            console.log(error);
            setErrors({ submit: error.message });
          } finally {
            updateFormState({ isSubmitting: false });
          }
        }}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <ClaimFormFooter
              goBack={goBack}
              isFormSubmitting={formState.isSubmitting}
            />
          </form>
        )}
      </Formik>
    </Box>
  );
}

ClaimReview.propTypes = {
  goBack: PropTypes.func,
  member: PropTypes.shape({
    coverages: PropTypes.arrayOf(PropTypes.shape({
      planCoverageId: PropTypes.number,
      coverageId: PropTypes.number,
    })),
    policyMasterId: PropTypes.number,
    programId: PropTypes.number,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    zipCode2: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string
  }),
  onSubmitClaim: PropTypes.func,
  dealerInfo: PropTypes.object,
  orderInfo: PropTypes.object,
  claimContactInfo: PropTypes.object
};
